import axios from 'axios'
import laroute from '~/laroute'
import store from '~/store'

// state
export const state = {
  inventory_adjustment: {},
  inventory_adjustments: [],
  transfer_codes: [],
  old_qty: 0,
  total: 0
}

// getters
export const getters = {
  transfer_codes: state => state.transfer_codes,
  inventory_adjustments: state => state.inventory_adjustments,
  inventory_adjustment: state => state.inventory_adjustment,
  old_qty: state => state.old_qty,
  total: state => state.total
}

// mutations
export const mutations = {

  TRANSFER_CODES (state, data) {
    state.transfer_codes = data
  },

  INVENTORY_ADJUSTMENTS (state, data) {
    state.inventory_adjustments = data
  },

  ADD_INVENTORY_ADJUSTMENT (state, data) {
    state.inventory_adjustment = data
  },

  TOTAL (state, data) {
    state.total = data
  },

  OLD_QTY (state, data) {
    state.old_qty = data
  }
}

// actions
export const actions = {
  async fetchAll ({ commit }, filterData) {
    const { data } = await axios.get(laroute.route('inventory_adjustment_filter', { companyAbbr: store.getters['auth/company'], ...filterData }))
    commit('INVENTORY_ADJUSTMENTS', data.items)
    commit('TOTAL', data.total)
  },

  async fetchTransferCodes ({ commit }) {
    const transferCodes = await axios.get(laroute.route('transfer_codes_list'))
    commit('TRANSFER_CODES', transferCodes.data)
  },

  async getOldQty ({ commit }, data) {
    const oldQtyData = await axios.get(laroute.route('get_qty_items_on_location', {
      companyAbbr: store.getters['auth/company'],
      stockLocationId: data.location,
      itemMasterId: data.part_number
    }))
    commit('OLD_QTY', oldQtyData.data)
  },

  async addInventoryAdjustment ({ commit }, data) {
    const response = await axios.put(laroute.route('create_inventory_adjustment',
      { companyAbbr: store.getters['auth/company'] }),
    data)

    commit('ADD_INVENTORY_ADJUSTMENT', response.data.inventory_adjustment)
  }

}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/adjustInventory.js